import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/AppointmentDetails/components/CarDetails/components/CarTyresModal/CarTyresModal.scss";
import { Tyres } from "modules/CarDetails/components";

import type { Appointment } from "models";

type CarTyresModalProps = {
  appointment: Appointment;
  open: boolean;
  onClose: () => void;
};

export const CarTyresModal = ({ appointment, open, onClose }: CarTyresModalProps) => {
  const { t } = useTranslation();

  if (!appointment.car) return;

  return (
    <>
      <Modal open={open} onClose={onClose} size="large" className="CarTyresModal">
        <Modal.Header className="CarTyresModal-header">
          <div className="CarTyresModal-header-title">
            <Icon className="tire" /> {t("v8_tyres", "Tyres")}
          </div>
          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark grey" />
          </Button>
        </Modal.Header>
        <Modal.Content>
          <Tyres car={appointment.car} appointment_id={appointment.id} />
        </Modal.Content>
      </Modal>
    </>
  );
};
